import React, { useState } from 'react'
import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, addRow, isFinalSubmitting, setIsFinalSubmitting, history }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table
                        className="assessment-table inspn-assessment-table"
                        cellSpacing={0}
                    >
                        <tbody>
                            <tr className="bghed">
                                <td rowSpan={2} className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td rowSpan={2} className="hd-s2 pd10">
                                    <p>Grand Block Name</p>
                                </td>
                                <td rowSpan={2} className="hd-s2 pd10">
                                    <p>Block No</p>
                                </td>
                                <td colSpan={2} className="hd-s1 pd10">
                                    <p>Hull Inspection</p>
                                </td>
                                <td colSpan={2} className="hd-s1 pd10">
                                    <p>Surface Prep. Inspn </p>
                                </td>
                                <td colSpan={2} className="hd-s1 pd10">
                                    <p>Paint Final Inspn </p>
                                </td>
                                <td colSpan={3} className="hd-s1 pd10">
                                    <p>Machinery and Electrical Insp</p>
                                </td>
                                <td colSpan={3} className="hd-s1 pd10">
                                    <p>Outfitting Insp</p>
                                </td>
                            </tr>
                            <tr className="bghed">
                                <td className="hd-s2 pd10">
                                    <p>Yard Sch</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Inspn Date</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Yard Sch</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Inspn Date</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Yard Sch</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Inspn Date</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Equipment</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Yard Sch</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Inspn Date</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Item</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Yard Sch</p>
                                </td>
                                <td className="hd-s2 pd10">
                                    <p>Inspn Date</p>
                                </td>
                            </tr>
                            {state.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">{index + 1}.</p>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.grand_block_name.name}
                                                value={item.grand_block_name.value}
                                                onChange={(e) => { onChange(item.grand_block_name.name, e.target.value, index) }}
                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.block_no.name}
                                                value={item.block_no.value}
                                                onChange={(e) => { onChange(item.block_no.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.hull_inspection_yard_sch.name}
                                                value={item.hull_inspection_yard_sch.value}
                                                onChange={(e) => { onChange(item.hull_inspection_yard_sch.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control narrow-date"
                                                placeholder=""
                                                name={item.hull_inspection_inspn_date.name}
                                                value={item.hull_inspection_inspn_date.value}
                                                onChange={(e) => { onChange(item.hull_inspection_inspn_date.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.surface_prep_inspn_yard_sch.name}
                                                value={item.surface_prep_inspn_yard_sch.value}
                                                onChange={(e) => { onChange(item.surface_prep_inspn_yard_sch.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control narrow-date"
                                                placeholder=""
                                                name={item.surface_prep_inspn_inspn_date.name}
                                                value={item.surface_prep_inspn_inspn_date.value}
                                                onChange={(e) => { onChange(item.surface_prep_inspn_inspn_date.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.paint_final_inspn_yard_sch.name}
                                                value={item.paint_final_inspn_yard_sch.value}
                                                onChange={(e) => { onChange(item.paint_final_inspn_yard_sch.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control narrow-date"
                                                placeholder=""
                                                name={item.paint_final_inspn_inspn_date.name}
                                                value={item.paint_final_inspn_inspn_date.value}
                                                onChange={(e) => { onChange(item.paint_final_inspn_inspn_date.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.machinery_and_electrical_insp_equipment.name}
                                                value={item.machinery_and_electrical_insp_equipment.value}
                                                onChange={(e) => { onChange(item.machinery_and_electrical_insp_equipment.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.machinery_and_electrical_insp_yard_sch.name}
                                                value={item.machinery_and_electrical_insp_yard_sch.value}
                                                onChange={(e) => { onChange(item.machinery_and_electrical_insp_yard_sch.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control narrow-date"
                                                placeholder=""
                                                name={item.machinery_and_electrical_insp_inspn_date.name}
                                                value={item.machinery_and_electrical_insp_inspn_date.value}
                                                onChange={(e) => { onChange(item.machinery_and_electrical_insp_inspn_date.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.outfitting_insp_item.name}
                                                value={item.outfitting_insp_item.value}
                                                onChange={(e) => { onChange(item.outfitting_insp_item.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.outfitting_insp_yard_sch.name}
                                                value={item.outfitting_insp_yard_sch.value}
                                                onChange={(e) => { onChange(item.outfitting_insp_yard_sch.name, e.target.value, index) }}

                                            />
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control narrow-date"
                                                placeholder=""
                                                name={item.outfitting_insp_inspn_date.name}
                                                value={item.outfitting_insp_inspn_date.value}
                                                onChange={(e) => { onChange(item.outfitting_insp_inspn_date.name, e.target.value, index) }}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}


                            <tr className="addmoreitem">
                                <td className="td-s1" colSpan={15}>
                                    <button type="button" className="btn btn-link" onClick={() => { addRow() }}>
                                        + Add New Block
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="final-checkbox">
                        <div class="form-check">
                            <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                            <label class="form-check-label" for="productdiscountCheck1">Send to Office for Review</label>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.production.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)